import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-200 py-10 md:py-14">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-excel-2-line text-base text-white"></i>
              </div>
              <span className="font-heading text-lg text-white">CSS Spreadsheet</span>
            </div>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed">
              Your trusted source for CSSBuy spreadsheet guides, agent comparisons, and verified shopping databases. Updated daily for the global rep shopping community.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Home</Link></li>
              <li><a href="#categories" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Categories</a></li>
              <li><Link to="/guides" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Shopping Guides</Link></li>
              <li><Link to="/article/cssbuy-spreadsheet-complete-guide" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">CSSBuy Guide</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">Agent Platforms</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">CSSBuy Sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Kakobuy Spreadsheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Superbuy Spreadsheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-background-300 hover:text-white transition-colors">Oopbuy Spreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">Shop Now</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200"
            >
              Buy It Now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <p className="text-xs text-background-400 mt-4 leading-relaxed">
              Explore thousands of products through our curated spreadsheet databases. Free access, updated daily.
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} CSS Spreadsheet Hub. All rights reserved.
          </p>
          <p className="text-xs text-background-400">
            External links open on <strong>kaspreadsheet.com</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}